var map = {
	"./Cisco-logo.png": 6327,
	"./adobe.png": 3726,
	"./apc.png": 9545,
	"./aws.png": 2896,
	"./azure.png": 8362,
	"./cisco.png": 778,
	"./dell.png": 7728,
	"./dell_emc.png": 3671,
	"./dellemc.png": 103,
	"./fortinet.png": 9209,
	"./fujitsu.png": 8837,
	"./hpe.png": 6641,
	"./ibm.png": 6070,
	"./juniper.png": 3761,
	"./mc.png": 9461,
	"./microsoft.png": 8773,
	"./nec.png": 4985,
	"./paloalto.png": 7427,
	"./redhat.png": 60,
	"./seagate.png": 2883,
	"./sun.png": 5561,
	"./synology.png": 7930,
	"./vmware.png": 4741,
	"./watchguard.png": 3838
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7722;